export const CustomerUserConfigLayoutType = {
  TradingLayout: 'TradingLayout',
  SwapLayout: 'SwapLayout',
  TradingLadderLayout: 'TradingLadderLayout',
  WatchListTradingLayout: 'WatchListTradingLayout',
  SimpleRFQLayout: 'SimpleRFQLayout',
  SettingsLayout: 'SettingsLayout',
  PortfolioLayout: 'PortfolioLayout',
  AddressesLayout: 'AddressesLayout',
  FeeTiersLayout: 'FeeTiersLayout',
  MarketDataCardsLayout: 'MarketDataCardsLayout',
  IFrameTestLayout: 'IFrameTestLayout',
} as const;
export type CustomerUserConfigLayoutType =
  (typeof CustomerUserConfigLayoutType)[keyof typeof CustomerUserConfigLayoutType];

/**
 * TODO: Figure out a little more elegant way of mapping these things as either
 * global or protected layouts, as well as to specific Layouts, so that downstream,
 * we can easily generate types with keyof typeof and ensure that we provide some
 * guardrails to our key lookups, no matter which particular Layout arrangements
 * we're dealing with.
 */

// Global Demo Layouts
export const GlobalCustomerUserConfigTradingLayoutArrangements = {
  Default: 'Default',
  SingleSymbolView: 'SingleSymbolView',
  WatchlistAndMarketDataCards: 'WatchlistAndMarketDataCards',
  CandlesticksAndMarketDataCards: 'CandlesticksAndMarketDataCards',
  MarketDataCards: 'MarketDataCards',
  WatchlistCandlesticksMarketDataCards: 'WatchlistCandlesticksMarketDataCards',
} as const;
export type GlobalCustomerUserConfigTradingLayoutArrangements =
  (typeof GlobalCustomerUserConfigTradingLayoutArrangements)[keyof typeof GlobalCustomerUserConfigTradingLayoutArrangements];

// WM Layouts
export const ProtectedCustomerUserConfigTradingLayoutArrangements = {
  WMLayout1: 'WMLayout1',
  WMLayout2: 'WMLayout2',
} as const;
export type ProtectedCustomerUserConfigTradingLayoutArrangements =
  (typeof ProtectedCustomerUserConfigTradingLayoutArrangements)[keyof typeof ProtectedCustomerUserConfigTradingLayoutArrangements];

export const CustomerUserConfigSwapLayoutArrangements = {
  // Global Demo Layouts
  [GlobalCustomerUserConfigTradingLayoutArrangements.SingleSymbolView]: 'Single Symbol View',
  [GlobalCustomerUserConfigTradingLayoutArrangements.WatchlistAndMarketDataCards]: 'Watchlist + Market Data Cards',
  [GlobalCustomerUserConfigTradingLayoutArrangements.CandlesticksAndMarketDataCards]:
    'Candlesticks + Market Data Cards',
  [GlobalCustomerUserConfigTradingLayoutArrangements.MarketDataCards]: 'Market Data Cards',
};

export const CustomerUserConfigTradingLayoutArrangements = {
  // WM Layouts
  [ProtectedCustomerUserConfigTradingLayoutArrangements.WMLayout1]: 'WM Layout 1',
  [ProtectedCustomerUserConfigTradingLayoutArrangements.WMLayout2]: 'WM Layout 2',

  // Global Demo Layouts
  [GlobalCustomerUserConfigTradingLayoutArrangements.SingleSymbolView]: 'Single Symbol View',
  [GlobalCustomerUserConfigTradingLayoutArrangements.WatchlistAndMarketDataCards]: 'Watchlist + Market Data Cards',
  [GlobalCustomerUserConfigTradingLayoutArrangements.CandlesticksAndMarketDataCards]:
    'Candlesticks + Market Data Cards',
  [GlobalCustomerUserConfigTradingLayoutArrangements.MarketDataCards]: 'Market Data Cards',
  [GlobalCustomerUserConfigTradingLayoutArrangements.WatchlistCandlesticksMarketDataCards]:
    'Watchlist, Candlesticks, Market Data Cards',
};

export type CustomerUserConfigLayoutArrangements<T> = Map<CustomerUserConfigLayoutType, T>;

export const CustomerUserConfigLayoutNavigationTypes = {
  Sidebar: 'Sidebar',
  Header: 'Header',
  SidebarHeaderToggle: 'SidebarHeaderToggle',
  CompactHeader: 'CompactHeader',
  None: 'None',
} as const;
export type CustomerUserConfigLayoutNavigationTypes =
  (typeof CustomerUserConfigLayoutNavigationTypes)[keyof typeof CustomerUserConfigLayoutNavigationTypes];

export const CustomerUserConfigLayoutTypesAndArrangements: CustomerUserConfigLayoutArrangements<
  typeof CustomerUserConfigTradingLayoutArrangements | typeof CustomerUserConfigSwapLayoutArrangements
> = new Map([
  [CustomerUserConfigLayoutType.TradingLayout, CustomerUserConfigTradingLayoutArrangements],
  [CustomerUserConfigLayoutType.SwapLayout, CustomerUserConfigSwapLayoutArrangements],
]);
